export interface IExtractAndReplaceYoutubeItem {
  /** Полное HTML-тело iframe */
  outerHtml: string;
  /** Id ролика */
  id: string;
}

export interface IExtractAndReplaceYoutube {
  /** HTML-контент */
  html: string;
  /** Коллекция параметров для ролика */
  items: IExtractAndReplaceYoutubeItem[];
}

/**
 * 1. Извлекает из HTML все iframe с параметрами
 * 2. Вырезает все iframe из HTML и заменяет пустым div'ом
 */
export const extractAndReplaceYoutube = (html: string): IExtractAndReplaceYoutube => {
  const pattern = /<iframe[^>]*?(?:src="(?:https:)?\/\/www\.youtube\.com\/embed\/([^?]+)[^"]*?")[^>]*?><\/iframe>/gis;
  const items = [] as IExtractAndReplaceYoutubeItem[];
  let match;

  if (!html) {
    return {
      html: '',
      items,
    };
  }

  while ((match = pattern.exec(html))) {
    items.push({
      outerHtml: match[0],
      id: match[1],
    });
  }

  return {
    html: items.reduce((acc, item) => {
      return acc.replace(item.outerHtml, `<div id="${item.id}"></div>`);
    }, html),
    items,
  };
};
